export default "__VITE_ASSET__CGbS3Ni4__"